import { apiReports } from '@/api/instance'
import type {
  FuelReportData,
  FuelReportFinalItem,
  ReportFetchParams,
  ReportFuelFetchParams,
  ReportRegistry,
  TCProps,
  UseFuelBlock,
  UseMileageBlock,
  UseParkBlock,
} from '@/api/models/reports'

export const reportsApi = apiReports.injectEndpoints({
  endpoints: (builder) => ({
    getUseOfTheParkBlock: builder.mutation<
      UseParkBlock,
      {
        from: string
        to: string
        type: 'week' | 'year'
      }
    >({
      query: (params) => ({
        url: '/reports/use-of-the-park-block',
        params,
      }),
    }),
    getUseOfTheFuelBlock: builder.mutation<
      UseFuelBlock,
      {
        to: string
        from: string
        type: 'week' | 'year'
      }
    >({
      query: (params) => ({
        url: '/reports/use-of-the-fuel-block',
        params,
      }),
    }),
    getFuelReportFinalData: builder.query<
      FuelReportFinalItem[],
      ReportFetchParams
    >({
      query: (params) => ({
        url: params.state_numbers
          ? `/reports/final-fuel-report?${params.state_numbers}`
          : '/reports/final-fuel-report',
        params: {
          per_page: params.per_page,
          page: params.page,
          to: params.to,
          from: params.from,
          //state_numbers: params.state_numbers,
        },
      }),
    }),
    getFuelReportData: builder.query<FuelReportData, ReportFuelFetchParams>({
      query: (params) => ({
        url: params.state_numbers
          ? `/reports/fuel-report?${params.state_numbers}`
          : '/reports/fuel-report',
        params: {
          per_page: params.per_page,
          page: params.page,
          to: params.to,
          from: params.from,
          fuel_id: params.fuel_id,
          //state_numbers: params.state_numbers,
        },
      }),
    }),
    getRegistryReportData: builder.query<ReportRegistry, ReportFetchParams>({
      query: (params) => ({
        url: params.state_numbers
          ? `/reports/registry-report?${params.state_numbers}`
          : '/reports/registry-report',
        params: {
          per_page: params.per_page,
          page: params.page,
          to: params.to,
          from: params.from,
          //state_numbers: params.state_numbers,
        },
      }),
    }),
    getTC: builder.query<TCProps, null>({
      query: () => ({
        url: '/vehicles',
      }),
    }),
    getGroupMileageBlock: builder.mutation<
      UseMileageBlock,
      { to: string; from: string; type: 'week' | 'year' }
    >({
      query: (params) => ({
        url: '/reports/group-mileage-block',
        params,
      }),
    }),

    getFuelReportFile: builder.mutation({
      queryFn: async ({ from, to }, api, extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: `/reports/excel?from=${from}&to=${to}`,
          method: 'GET',
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          responseHandler: (response: any) => response.blob(),
        })
        const hiddenElement = document.createElement('a')
        const url = window.URL || window.webkitURL
        const blobPDF = url.createObjectURL(result.data as Blob)
        hiddenElement.href = blobPDF
        hiddenElement.target = '_blank'
        hiddenElement.download = `_report.xlsx`
        hiddenElement.click()
        return { data: null }
      },
    }),
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // getFuelReportFile: builder.mutation<any, { from: string; to: string }>({

    //   query: (params) => ({
    //     url: '/reports/excel',
    //     method: 'GET',
    //     responseType: 'blob',
    //     params,
    //   }),
    // }),
  }),
})

export const {
  useGetUseOfTheParkBlockMutation,
  useGetUseOfTheFuelBlockMutation,
  useGetFuelReportFinalDataQuery,
  useGetFuelReportDataQuery,
  useGetRegistryReportDataQuery,
  useGetTCQuery,
  useGetGroupMileageBlockMutation,
  useGetFuelReportFileMutation,
} = reportsApi
